import React, { useEffect, useRef, useState } from "react";
import { BoardApprovalAssignmentConfig } from "./component/BoardApprovalAssignmentConfig";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import Buttons from "../../components/ui/button/Buttons";
import SwalAlert from "../../services/swalService/SwalService";
import { useAssignCorporateApplicationToBoardMutation, useBoardApprovalAssignmentListMutation } from "../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";

const BoardApprovalAssignment = () => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const { success } = SwalAlert();
  const [selectedRows, setSelectedRows] = useState([]);
  const [boardApprovalAssignmentList, { isSuccess: isSuccessboardApprovalAssignmentList, isLoading: isLoadingboardApprovalAssignmentList, data: getboardApprovalAssignmentListDataResponse, },] = useBoardApprovalAssignmentListMutation();
  const [assignCommitteeApproval, { isSuccess: isSuccessAssignCommitteeApproval, isLoading: isLoadingAssignCommitteeApproval, data: getAssignCommitteeApprovalResponse, },] = useAssignCorporateApplicationToBoardMutation();

  useEffect(() => {
    boardApprovalAssignmentList(paginationRequest);
  }, []);

  useEffect(() => {
    if (!isLoadingboardApprovalAssignmentList && isSuccessboardApprovalAssignmentList && getboardApprovalAssignmentListDataResponse) {
      setPaginationRequest((prev) => ({ ...prev, totalCount: getboardApprovalAssignmentListDataResponse.totalCount, }));
      setDataSource(getboardApprovalAssignmentListDataResponse?.itemList);
    }
  }, [isLoadingboardApprovalAssignmentList, isSuccessboardApprovalAssignmentList, getboardApprovalAssignmentListDataResponse,]);

  useEffect(() => {
    if (!isLoadingAssignCommitteeApproval && isSuccessAssignCommitteeApproval && getAssignCommitteeApprovalResponse) {
      if (!getAssignCommitteeApprovalResponse?.hasError) {
        boardApprovalAssignmentList(paginationRequest);
        success("Board Approval Assignment Successfully")
        setSelectedRows([])
      }
    }
  }, [isLoadingAssignCommitteeApproval, isSuccessAssignCommitteeApproval, getAssignCommitteeApprovalResponse,]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    boardApprovalAssignmentList(updatedPaginationRequest);
  };

  const hadleHeaderSelect = (dataSource, event) => {
    const isChecked = event?.target?.checked;
    if (isChecked) {
      setSelectedRows(dataSource);
    } else {
      setSelectedRows([]);
    }
  }

  const handleRowSelection = (selectedRow) => {
    const exists = selectedRows?.find((row) => row?.sgbcCorporateMemberId === selectedRow?.sgbcCorporateMemberId);
    if (exists) {
      let filterRow = selectedRows?.filter((row) => row?.sgbcCorporateMemberId !== selectedRow?.sgbcCorporateMemberId);
      setSelectedRows(filterRow)
    } else {
      let rowSelect =[...selectedRows,selectedRow]
      setSelectedRows(rowSelect)
    }
  };



  const handleAssign = () => {
    const request = {
      AssignCorporateApplication: selectedRows.map((item) => ({
        SGBCCorporateMemberId: item?.sgbcCorporateMemberId || null,
      })),
    };
     assignCommitteeApproval(request);
  };


  return (
    <div className="board-approval-assignment">
      <div className="member-list">
        <FinalMolGrid
          ref={molGridRef}
          configuration={BoardApprovalAssignmentConfig}
          dataSource={dataSource}
          allowPagination={false}
          isLoading={isLoadingboardApprovalAssignmentList}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onHandleRowSelect={handleRowSelection}
          onHeaderCheckboxChange={hadleHeaderSelect}
        />
      </div>
      <div className="d-flex justify-content-end mt-5">
        <Buttons
          buttonText={"Send for Approval"}
          buttonTypeClassName="success-btn btn"
          onClick={handleAssign}
          isLoading={isLoadingAssignCommitteeApproval}
          isDisable={isLoadingAssignCommitteeApproval  || selectedRows.length == 0}
        />
      </div>
    </div>
  );
};
export default BoardApprovalAssignment;
